import VehiclePlateIcon from '@/common/assets/icons/vehiclePlateIcon.svg?react';
import FilledArrowDown from '@/common/components/atachments/plateLetterAttachment';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import usePlateFocusInputs from '@/common/components/base/input/plate/hook/usePlateFocusInputs';
import { VehiclePlateRules } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.rules';
import { VehiclePlateProps } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import VehiclePlateLetterModal from '@/common/components/base/input/plate/vehiclePlateInput/VehiclePlateLetter.modal';
import NumberInput from '@/common/components/base/input/textInput copy/NumberInput';
import Typography from '@/common/components/base/typography/Typography';
import { plateLetterQueryOptions } from '@/common/queries/plateLetter/plateLetterQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { FC, useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { css, cx } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
const defaultValue = {
  left: '',
  right: '',
  letter: { label: '', value: '' },
  iran: '',
};
const VehiclePlateInput: FC<VehiclePlateProps> = ({
  onChange,
  value: plateValue,
  requiredError,
}) => {
  const methods = useForm<any>({
    defaultValues: {
      left: plateValue?.plate.left || '',
      right: plateValue?.plate.right || '',
      letter: {
        label: plateValue?.plate.letter?.label || '',
        value: plateValue?.plate.letter?.value || '',
      },
      iran: plateValue?.plate.iran || '',
    },
    mode: 'onChange',
  });
  const formData = useWatch({ control: methods.control });
  const { focus } = usePlateFocusInputs<keyof typeof defaultValue>({ methods });
  useEffect(() => {
    const { iran, left, letter, right } = formData;
    const plate = `${left}${letter?.label}${right}${iran}`;
    onChange({
      plateString: plate,
      plate: {
        ...formData,
      },
    });
  }, [formData]);

  const { data } = useQuery(plateLetterQueryOptions());
  const letterOnChange = ({
    onClose,
    value,
  }: {
    onClose: () => void;
    value: string;
  }) => {
    onClose();
    focus({
      value,
      nextName: 'right',
      previous: 'left',
      length: 1,
    });
    methods.setValue('letter', {
      label: value,
      value,
    });
  };

  return (
    <FormProvider {...methods}>
      <Box>
        <Typography>پلاک</Typography>
        <Box
          className={css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            width: '100%',
            border: '1px solid',
            borderColor: requiredError ? 'red' : 'gray',
            borderRadius: '8px',
            backgroundColor: 'gray-3',
          })}
        >
          <Box display="flex" alignItems="center" gap="1rem" mr="8px">
            <Box flex="3">
              <NumberInput
                onChange={(value) =>
                  focus({ value, nextName: '', previous: 'right', length: 2 })
                }
                name="iran"
                className={cx(inputStyle, css({ minW: '50px' }))}
                maxLength={2}
                rules={VehiclePlateRules.left}
                inputProps={{ textAlign: 'center' }}
                placeholder="55"
              />
            </Box>
            <Box
              borderRight="1px solid"
              borderColor="black-4"
              w="1px"
              height="2.2rem"
            />
            <Box display="flex" alignItems="center" gap="4px" flex="13">
              <Box flex="3">
                <NumberInput
                  onChange={(value) =>
                    focus({
                      value,
                      nextName: 'iran',
                      previous: 'letter',
                      length: 3,
                    })
                  }
                  maxLength={3}
                  name="right"
                  className={cx(inputStyle, css({ minW: '70px' }))}
                  rules={VehiclePlateRules.left}
                  inputProps={{ textAlign: 'center' }}
                  placeholder="555"
                />
              </Box>
              <Box flex="4">
                <ModalInput
                  name="letter"
                  hasErrorMassage={false}
                  hasLabel={false}
                  rules={VehiclePlateRules.left}
                  inputProps={{
                    className: cx(inputStyle, css({ minW: '50px' })),
                    textAlign: 'center',
                    placeholder: 'الف',
                  }}
                  endAttachments={[FilledArrowDown]}
                >
                  {(onClose) => (
                    <VehiclePlateLetterModal
                      onClick={(value) => {
                        letterOnChange({ onClose, value });
                      }}
                      options={data ?? []}
                    />
                  )}
                </ModalInput>
              </Box>

              <Box flex="2">
                <NumberInput
                  onChange={(value) =>
                    focus({
                      value,
                      nextName: 'letter',
                      previous: '',
                      length: 2,
                    })
                  }
                  name="left"
                  maxLength={2}
                  className={cx(inputStyle, css({ minW: '50px' }))}
                  rules={VehiclePlateRules.left}
                  inputProps={{ textAlign: 'center' }}
                  placeholder="55"
                />
              </Box>
            </Box>
          </Box>
          <Box>
            <VehiclePlateIcon
              className={css({ borderRadius: '8px 0 0 8px' })}
            />
          </Box>
        </Box>
      </Box>{' '}
      {requiredError && (
        <Typography height="24px" color="red-1" textStyle="b4">
          {requiredError}
        </Typography>
      )}
    </FormProvider>
  );
};

export default VehiclePlateInput;

const inputStyle = css({
  border: '0px',
  minHeight: '32px',
  p: 0,
});
